import React, { useContext, useEffect, useState } from "react";
import comment from "../../../assets/SkuList/comment.svg";
import "./style.scss";
import Button from "../../../common/Button";
import model1 from "../../../assets/SkuList/model-1.jpg";
import BackIcon from "../../../assets/Header/backIcon.svg";
import UploadColorSwatches from "../UploadColorSwaches";
import { Empty, message, Modal, Tag, Tooltip } from "antd";
import {
  useAddActionToAddOnInDraftSku,
  useGetBatchSkuList,
  useRemoveAddOnServiceFromAnSku,
  useUpsertAddOnServiceToSku,
  useGetListAddOns,
  useDeleteDraftSkuForUser,
} from "../../../hooks/useOrderBatches";
import { useParams, useNavigate } from "react-router-dom";
import arrowIcon from "../../../assets/SkuList/arrowIcon.svg";
import plusIcon from "../../../assets/SkuList/plusIcon.svg";
import orderBatchesApi from "../../../apis/orderBatches";
import plus from "../../../assets/AddOnServices/plus.svg";
import deleteIcon from "../../../assets/AddOnServices/delete.svg";
import plusUpload from "../../../assets/AddOnServices/plus-upload.svg";
import checkIcon from "../../../assets/AddOnServices/check-circle.svg";
import editIcon from "../../../assets/SkuList/editIcon.svg";
import FilteredAddOnServices from "../FilteredAddOnServices";
import debounce from "lodash.debounce";
import commentIcon from "../../../assets/SkuList/comment-icon.svg";
import { BatchMarketPlaceContext } from "../../../context/batchProvider";
import Stepper from "../../Stepper";

const SkuList = () => {
  const [isUploadColorSwatches, setIsUploadColorSwaches] = useState(false);
  const params = useParams();
  const [skuListData, setSkuListData] = useState([]);
  const navigate = useNavigate();
  const [activeAddOns, setActiveAddOns] = useState({});
  const [activeActions, setActiveActions] = useState({});
  const [fileUpload, setFileUpload] = useState({});
  const [imageUrl, setImageUrl] = useState("");
  const [uploadPopup, setUploadPopup] = useState(false);
  const [selectedAddOn, setSelectedAddOn] = useState();
  const [selectedSku, setSelectedSku] = useState();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteAddOnData, setDeleteAddOnData] = useState();
  const [isListAddOns, setIsListAddOns] = useState(false);
  const [skuId, setSkuId] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [nextDisabled, setNextDisabled] = useState(true);
  const [showDeleteSkuModal, setShowDeleteSkuModal] = useState(false);
  const [deleteSkuId, setDeleteSkuId] = useState();
  const { getPresignedUrlForAddOns } = orderBatchesApi;
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { batch_skipPages } = useContext(BatchMarketPlaceContext);
  useEffect(() => {
    let disabled = false;
    skuListData.forEach((sku, id) => {
      sku.addOnServices.forEach((addOn, index) => {
        if (addOn.actions.length > 0) {
          if (addOn.actionResult.length === 0) {
            disabled = true;
          }
        }
      });
    });
    setNextDisabled(disabled);
  }, [skuListData]);

  const onSuccessaddActionToAddOn = (res) => {
    if (res.status === 200) {
      message.success("Add-On Success");
      getAllBatches();
    }
  };

  const onErroraddActionToAddOn = (err) => {
    message.error(err);
  };

  const { mutate: addActionToAddOn } = useAddActionToAddOnInDraftSku(
    onSuccessaddActionToAddOn,
    onErroraddActionToAddOn
  );
  const onSuccessGetBatchSkuList = (res) => {
    if (res.status === 200) {
      setSkuListData(res.data.skus);
      if (res.data.skus.length === 0) {
        navigate(`/upload-images/${params?.batchId}`);
      }
    }
  };
  const onErrorGetBatchSkuList = (err) => {
    console.log(err);
  };

  const { data, refetch: getAllBatches } = useGetBatchSkuList(
    "getBatchSkuList",
    params.batchId,
    onSuccessGetBatchSkuList,
    onErrorGetBatchSkuList
  );
  const onSuccessRemoveAddOnServiceFromAnSku = (res) => {
    if (res.status === 200) {
      message.success("Add-On Deleted");
      setShowDeleteModal(false);
      getAllBatches();
    }
  };

  const onErrorRemoveAddOnServiceFromAnSku = (err) => {
    message.error(err);
  };

  const { mutate: removeAddOnServiceFromAnSku } =
    useRemoveAddOnServiceFromAnSku(
      onSuccessRemoveAddOnServiceFromAnSku,
      onErrorRemoveAddOnServiceFromAnSku
    );

  const handleModalClose = () => {
    setUploadPopup(false);
    getAllBatches();
  };
  const handleDeletAddOn = () => {
    let payload = {
      ...deleteAddOnData,
      batchId: params.batchId,
    };
    removeAddOnServiceFromAnSku(payload);
  };
  const onSuccessDeleteDraftSkuForUser = (res) => {
    if (res.status === 200) {
      message.success("Sku Deleted");
      setShowDeleteSkuModal(false);
      getAllBatches();
    }
  };

  const onErrorDeleteDraftSkuForUser = (err) => {
    message.error(err);
  };

  const { mutate: deleteDraftSkuForUser } = useDeleteDraftSkuForUser(
    onSuccessDeleteDraftSkuForUser,
    onErrorDeleteDraftSkuForUser
  );
  const handleDeleteSku = () => {
    let payload = {
      draftSkuId: deleteSkuId,
      batchId: params.batchId,
    };
    deleteDraftSkuForUser(payload);
  };
  const saveChanges = async (updatedList) => {
    setIsSaving(true);
    try {
      setTimeout(() => {
        setIsSaving(false);
      }, 1000);
    } catch (error) {
      setIsSaving(false);
    }
  };

  const debouncedSave = debounce(
    (updatedList) => saveChanges(updatedList),
    1000
  );

  useEffect(() => {
    debouncedSave(skuListData);
    return () => debouncedSave.cancel();
  }, [skuListData]);

  const getUploadColorSwatches = () => {
    return (
      <Modal
        title="Upload Color Swaches"
        open={isUploadColorSwatches}
        footer={null}
        width="85%"
        height="80dvh"
        centered
        className="add_category_modal_wrapper"
        onCancel={() => setIsUploadColorSwaches(false)}
      >
        <UploadColorSwatches isUploadColorSwatches={isUploadColorSwatches} />
      </Modal>
    );
  };

  const getUploadPopup = () => {
    return (
      <Modal
        title={selectedAddOn?.actions[0]?.actionDescription}
        open={uploadPopup}
        footer={null}
        width="90%"
        height="90dvh"
        className="angle_set_details_modal_wrapper"
        onCancel={() => setUploadPopup(false)}
      >
        <UploadColorSwatches
          selectedAddOn={selectedAddOn}
          selectedSku={selectedSku}
          handleCloseModal={handleModalClose}
          isColorCode={
            selectedAddOn?.actions[0]?.actionDescription ===
            "Upload Color Swatches to Create Colorways"
          }
        />
      </Modal>
    );
  };
  const getDeleteModal = () => {
    return (
      <Modal
        title="Delete Add On"
        open={showDeleteModal}
        onOk={() => handleDeletAddOn()}
        onCancel={() => setShowDeleteModal(false)}
        className="delete_modal"
        centered
      >
        <p>Do you want to delete add-on?</p>
      </Modal>
    );
  };
  const getDeleteSkuModal = () => {
    return (
      <Modal
        title="Delete Sku"
        open={showDeleteSkuModal}
        onOk={() => handleDeleteSku()}
        onCancel={() => setShowDeleteSkuModal(false)}
        className="delete_modal"
        centered
      >
        <p>Do you want to delete sku?</p>
      </Modal>
    );
  };
  const toggleAddOn = (index) => {
    setActiveAddOns((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  // const toggleAddOn = (index) => {
  //   setActiveAddOns((prevState) => ({
  //     ...prevState,
  //     [index]: !prevState[index],
  //   }));
  // };

  const toggleAction = (addOnIndex, actionIndex) => {
    setActiveActions((prevState) => ({
      ...prevState,
      [`${addOnIndex}-${actionIndex}`]:
        !prevState[`${addOnIndex}-${actionIndex}`],
    }));
  };
  const getKeyPresignedUrl = async (
    file,
    skuId,
    packageId,
    serviceId,
    variantId,
    actionType,
    actionId
  ) => {
    let uploadSuccess = true;
    try {
      if (!file[0].name || !file[0].type) {
        uploadSuccess = false;
        throw new Error(
          "Invalid file detected. Ensure the file has a valid name and type."
        );
      }

      const resp = await getPresignedUrlForAddOns({
        filename: file[0].name,
        mimeType: file[0].type,
      });

      if (resp?.status !== 200 || !resp?.data?.key || !resp?.data?.url) {
        uploadSuccess = false;
        throw new Error("Invalid response from getPresignedUrl.");
      }

      const { key, url } = resp.data;

      const uploadResp = await fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": file[0].type,
        },
        body: file[0],
      });

      if (!uploadResp.ok) {
        uploadSuccess = false;

        throw new Error(`File upload failed with status: ${uploadResp.status}`);
      }

      let payload = {
        skuId: skuId,
        serviceId: serviceId,
        packageId: packageId,
        variantId: variantId,
        selectedActionType: actionType,
        actionId: actionId,
        actionData: [key],
      };
      addActionToAddOn(payload);
    } catch (err) {
      uploadSuccess = false;
      message.error(
        err?.response?.data?.message ||
          err.message ||
          "An error occurred during upload."
      );
    } finally {
      // setIsUploadingImage(false);
    }
    return uploadSuccess;
  };

  const handleUploadImage = async (
    file,
    skuId,
    packageId,
    serviceId,
    variantId,
    actionType,
    actionId
  ) => {
    if (file.length > 0) {
      setImageUrl("");
      setFileUpload((prev) => ({
        ...prev,
        [skuId]: {
          ...prev[skuId],
          [variantId]: file,
        },
      }));
      getKeyPresignedUrl(
        file,
        skuId,
        packageId,
        serviceId,
        variantId,
        actionType,
        actionId
      );
    }
  };
  const handleUploadAddOn = (skuId, addOnIndex, actionIndex) => {
    document
      ?.getElementById(`file-${skuId}-${addOnIndex}-${actionIndex}`)
      ?.click();
  };
  const handleVariantChange = (variantId, skuId, addOnId) => {
    const updatedData = skuListData.map((sku) => {
      if (sku?._id === skuId) {
        sku.addOnServices.forEach((addOn) => {
          if (addOn?._id === addOnId) {
            addOn.variant = variantId;
          }
        });
      }
      return { ...sku };
    });
    setSkuListData(updatedData);
  };
  const handlePackageChange = (e, skuId, addOnId) => {
    const updatedData = skuListData.map((sku) => {
      if (sku?._id === skuId) {
        sku.addOnServices.forEach((addOn) => {
          if (addOn?._id === addOnId) {
            addOn.package = e.target.value;
          }
        });
      }
      return { ...sku };
    });
    setSkuListData(updatedData);
  };
  const handleAddOnComment = (e, skuId, addOnId) => {
    const updatedData = skuListData.map((sku) => {
      if (sku?._id === skuId) {
        sku.addOnServices.forEach((addOn) => {
          if (addOn?._id === addOnId) {
            addOn.serviceObj.items.forEach((item) => {
              if (item.packageId === addOn.package) {
                item.variants.forEach((variant) => {
                  if (variant?._id === addOn.variant) {
                    variant.comment = e.target.value;
                  }
                });
              }
            });
          }
        });
      }
      return { ...sku };
    });
    setSkuListData(updatedData);
  };
  const onSuccessUpsertAddOnServiceToSku = (res) => {
    if (res.status === 200) {
      message.success("Add-On Updated");
      getAllBatches();
    }
  };

  const onErrorUpsertAddOnServiceToSku = (err) => {
    message.error(err);
  };

  const { mutate: upsertAddOnServiceToSku } = useUpsertAddOnServiceToSku(
    onSuccessUpsertAddOnServiceToSku,
    onErrorUpsertAddOnServiceToSku
  );

  const updateAddOn = (e, skuId, serviceId, packageId, variantId, comment) => {
    e.preventDefault();
    let payload = {
      draftSkuId: skuId,
      serviceId: serviceId,
      packageId: packageId,
      variantId: variantId,
      comments: [comment],
    };
    upsertAddOnServiceToSku(payload);
  };

  const addOnServiceAdded = () => {
    setIsListAddOns(false);
    getAllBatches();
  };

  const getFilteredList = () => {
    return (
      <Modal
        title="Add On Services"
        open={isListAddOns}
        footer={null}
        width="90%"
        height="90dvh"
        className="angle_set_details_modal_wrapper"
        onCancel={() => setIsListAddOns(false)}
      >
        <FilteredAddOnServices
          skuId={skuId}
          isServiceAdded={addOnServiceAdded}
          skuList={skuListData}
        />
      </Modal>
    );
  };

  const handleEditClick = (index, addOn, skuList) => {
    setSelectedIndex(index);
    setUploadPopup(true);
    setSelectedAddOn(addOn);
    setSelectedSku(skuList);
  };

  return (
    <div className="sku_wrapper">
      <div className="sku_list_container">
        {skuListData?.length > 0 ? (
          skuListData.map((skuList, index) => {
            return (
              <div className="sku_items_wrapper" key={index}>
                <div className="sku_header">
                  <div className="sku_left_details">
                    <div className="sku_details">
                      <h2 className="sku_title">
                        {skuList?.displayName}
                        <span className="count_of_images">
                          {skuList.files.length} Images
                        </span>
                      </h2>
                    </div>
                    <div className="delete_icon_wrapper">
                      <img
                        src={deleteIcon}
                        alt="deleteIcon"
                        onClick={() => {
                          setShowDeleteSkuModal(true);
                          setDeleteSkuId(skuList?._id);
                        }}
                      />
                    </div>
                  </div>
                  {!batch_skipPages?.includes("addOnService") && (
                    <div className="sku_add_on_header_wrapper">
                      <div className="text">
                        Add-On Services
                        {skuList.addOnServices?.some(
                          (addOn) =>
                            addOn.actions.length > 0 &&
                            addOn.actionResult.length === 0
                        ) && <Tag color="red">Action Required</Tag>}
                      </div>
                      <div
                        className="plus_icon_add_on"
                        onClick={() => {
                          setIsListAddOns(true);
                          setSkuId(skuList?._id);
                        }}
                      >
                        <img src={plus} alt="" />
                      </div>
                    </div>
                  )}
                  {/* {activeAddOns[index] ? (
                    <div
                      className="sku_add_on_header_wrapper"
                      onClick={() => toggleAddOn(index)}
                    >
                      Add-On Services
                    </div>
                  ) : (
                    <div className="sku_right_details">
                      <button
                        className="addOnBtn"
                        onClick={() => toggleAddOn(index)}
                      >
                        Add-On Services
                      </button>
                    </div>
                  )} */}
                </div>

                <div className="sku_items_container">
                  <div className="sku_items">
                    {skuList.files?.length > 0 &&
                      skuList.files?.map((file, id) => (
                        <div className="item" key={id}>
                          <div className="image">
                            <img src={file.image.thumbPath.url} alt="" />
                          </div>

                          {file.image.name.length > 10 ? (
                            <Tooltip
                              title={file.image.name}
                              placement="rightTop"
                            >
                              <span>{`${file.image.name.slice(
                                0,
                                10
                              )}...`}</span>
                            </Tooltip>
                          ) : (
                            file.image.name
                          )}
                        </div>
                      ))}
                  </div>
                  {!batch_skipPages.includes("addOnService") && (
                    <div className="add_on_list_container">
                      {skuList.addOnServices.map((addOn, addOnIndex) => {
                        return (
                          <div className="add_on_content" key={addOnIndex}>
                            <div className="add_on_list_header">
                              <div className="heading_title">
                                {addOn?.serviceName}
                              </div>
                              <div className="arrow_icon_wrapper">
                                <img
                                  src={deleteIcon}
                                  alt="arrowIcon"
                                  onClick={() => {
                                    setShowDeleteModal(true);
                                    setDeleteAddOnData({
                                      serviceId: addOn.service,
                                      draftSkuId: skuList?._id,
                                    });
                                  }}
                                />
                              </div>
                            </div>
                            {addOn.serviceObj.items.length > 1 && (
                              <div className="select_package_wrapper">
                                <select
                                  value={addOn.package}
                                  onChange={(e) =>
                                    handlePackageChange(
                                      e,
                                      skuList?._id,
                                      addOn?._id
                                    )
                                  }
                                  className="package_section"
                                >
                                  {addOn?.serviceObj.items.map((item) => (
                                    <option
                                      key={item?.packageId}
                                      value={item?.packageId}
                                    >
                                      {item?.packageName}
                                    </option>
                                  ))}
                                </select>
                                <img src={arrowIcon} alt="arrow" />
                              </div>
                            )}
                            <div className="variant_wrapper">
                              <div className="button_container">
                                {addOn.serviceObj.items
                                  .find(
                                    (item) => item.packageId === addOn.package
                                  )
                                  ?.variants.map((variant) => {
                                    return (
                                      <button
                                        key={variant?._id}
                                        className={`variant_button ${
                                          variant?._id === addOn.variant
                                            ? "active"
                                            : ""
                                        }`}
                                        // onClick={() =>
                                        //   handleVariantChange(
                                        //     variant?._id,
                                        //     skuList?._id,
                                        //     addOn?._id
                                        //   )
                                        // }
                                        onClick={(e) => {
                                          updateAddOn(
                                            e,
                                            skuList?._id,
                                            addOn.service,
                                            addOn.package,
                                            variant?._id
                                          );
                                        }}
                                      >
                                        {variant?.name}
                                      </button>
                                    );
                                  })}
                              </div>
                              <div className="arrow_wrapper">
                                <img
                                  src={arrowIcon}
                                  alt="arrow"
                                  className={
                                    activeActions[`${index}-${addOnIndex}`]
                                      ? ""
                                      : "rotate"
                                  }
                                  onClick={() =>
                                    toggleAction(index, addOnIndex)
                                  }
                                />
                              </div>
                            </div>
                            {activeActions[`${index}-${addOnIndex}`] && (
                              <>
                                <div className="add_on_details">
                                  <div className="features_wrapper">
                                    <div className="feature_heading">
                                      Includes{" "}
                                    </div>
                                    <ul>
                                      {addOn.serviceObj.items
                                        .find(
                                          (item) =>
                                            item.packageId === addOn.package
                                        )
                                        ?.variants.find(
                                          (variant) =>
                                            variant?._id === addOn.variant
                                        )
                                        ?.features.map((variantData) => {
                                          return (
                                            <li>
                                              <div className="icon_wrapper">
                                                <img
                                                  src={checkIcon}
                                                  alt="checkIcon"
                                                />
                                              </div>
                                              {variantData}
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                  <div className="image_comment_wrapper">
                                    <div className="image_container">
                                      <div className="before_image_wrapper">
                                        <div className="heading">Before</div>
                                        <div className="image_wrapper">
                                          <img src={model1} alt="before_img" />
                                        </div>
                                      </div>
                                      <div className="after_image_wrapper">
                                        <div className="heading">After</div>
                                        <div className="image_wrapper">
                                          <img src={model1} alt="before_img" />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="break" />
                                    <div className="comment_wrapper">
                                      <div className="heading">Comments</div>
                                      <textarea
                                        placeholder="Write your comment"
                                        value={
                                          addOn.serviceObj.items
                                            .find(
                                              (item) =>
                                                item.packageId === addOn.package
                                            )
                                            ?.variants.find(
                                              (variant) =>
                                                variant?._id === addOn.variant
                                            )?.comment
                                        }
                                        onChange={(e) =>
                                          handleAddOnComment(
                                            e,
                                            skuList?._id,
                                            addOn?._id
                                          )
                                        }
                                      />
                                      <button
                                        onClick={(e) =>
                                          updateAddOn(
                                            e,
                                            skuList?._id,
                                            addOn?.service,
                                            addOn?.package,
                                            addOn?.variant,
                                            addOn.serviceObj.items
                                              .find(
                                                (item) =>
                                                  item.packageId ===
                                                  addOn.package
                                              )
                                              ?.variants.find(
                                                (variant) =>
                                                  variant?._id === addOn.variant
                                              )?.comment
                                          )
                                        }
                                      >
                                        <img src={commentIcon} alt="" />
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </>
                            )}
                            <div className="add_on_upload_section">
                              {addOn?.actionResult?.length > 0
                                ? addOn.actionResult.map(
                                    (actionResult, index) => {
                                      return actionResult.imageArray.length >
                                        0 ? (
                                        actionResult.imageArray.map(
                                          (image, id) => {
                                            return (
                                              <div className="action_image_main_container">
                                                <div className="action_result_wrapper">
                                                  <img
                                                    src={image.imagePath.url}
                                                    alt=""
                                                  />
                                                </div>
                                                <div
                                                  className="edit_icon_wrapper"
                                                  onClick={() => {
                                                    setUploadPopup(true);
                                                    setSelectedAddOn(addOn);
                                                    setSelectedSku(skuList);
                                                  }}
                                                >
                                                  <img
                                                    src={editIcon}
                                                    alt="editIcon"
                                                  />
                                                </div>
                                              </div>
                                            );
                                          }
                                        )
                                      ) : (
                                        <>
                                          {actionResult?.image?.imagePath
                                            ?.url && (
                                            <div className="action_image_main_container">
                                              <div className="action_result_wrapper">
                                                <img
                                                  src={
                                                    actionResult?.image
                                                      ?.imagePath?.url
                                                  }
                                                  alt=""
                                                />
                                              </div>
                                              <div
                                                className="edit_icon_wrapper"
                                                onClick={() => {
                                                  setUploadPopup(true);
                                                  setSelectedAddOn(addOn);
                                                  setSelectedSku(skuList);
                                                }}
                                              >
                                                <img
                                                  src={editIcon}
                                                  alt="editIcon"
                                                />
                                              </div>
                                            </div>
                                          )}
                                          <div className="action_result_box">
                                            {actionResult.colorArray.map(
                                              (colorVal, index) => {
                                                return (
                                                  <div
                                                    key={index}
                                                    className="action_result_wrapper"
                                                    style={{
                                                      background:
                                                        colorVal?.colorMode ===
                                                        "hex"
                                                          ? colorVal?.color?.hex
                                                          : `rgba(${colorVal.color.rgba})`,
                                                    }}
                                                  >
                                                    <div
                                                      className="edit_icon_wrapper"
                                                      onClick={() =>
                                                        handleEditClick(
                                                          index,
                                                          addOn,
                                                          skuList
                                                        )
                                                      }
                                                    >
                                                      <img
                                                        src={editIcon}
                                                        alt="editIcon"
                                                      />
                                                    </div>
                                                  </div>
                                                );
                                              }
                                            )}
                                          </div>
                                        </>
                                      );
                                    }
                                  )
                                : addOn.actions.length > 0 &&
                                  addOn.actions.map((action, actionIndex) => (
                                    <>
                                      <div
                                        className="upload_box"
                                        onClick={() => {
                                          setUploadPopup(true);
                                          setSelectedAddOn(addOn);
                                          setSelectedSku(skuList);
                                        }}
                                        key={actionIndex}
                                      >
                                        <img src={plusUpload} alt="plusIcon" />
                                        <span>{action.actionDescription}</span>
                                        <input
                                          type="file"
                                          accept="image/png,image/jpg,image/jpeg, image/webp"
                                          id={`file-${skuList?._id}-${addOnIndex}-${actionIndex}`}
                                          onChange={(e) => {
                                            handleUploadImage(
                                              e.target.files,
                                              skuList?._id,
                                              addOn.package,
                                              addOn.service,
                                              addOn.variant,
                                              action?.actionTypes[0]
                                                ?.actionType,
                                              action?._id
                                            );
                                          }}
                                          onClick={(e) =>
                                            (e.target.value = null)
                                          }
                                          className="upload_more_images_btn_input"
                                          style={{ display: "none" }}
                                        />
                                      </div>
                                    </>
                                  ))}
                              {/* {addOn.actions.length > 0 &&
                              addOn.actions.map((action, actionIndex) => (
                                <>
                                  <div
                                    className="upload_box"
                                    onClick={() => {
                                      setUploadPopup(true);
                                      setSelectedAddOn(addOn);
                                      setSelectedSku(skuList);
                                    }}
                                    key={actionIndex}
                                  >
                                    <img src={plusUpload} alt="plusIcon" />
                                    <span>{action.actionDescription}</span>
                                    <input
                                      type="file"
                                      accept="image/png,image/jpg,image/jpeg, image/webp"
                                      id={`file-${skuList?._id}-${addOnIndex}-${actionIndex}`}
                                      onChange={(e) => {
                                        handleUploadImage(
                                          e.target.files,
                                          skuList?._id,
                                          addOn.package,
                                          addOn.service,
                                          addOn.variant,
                                          action.actionTypes[0].actionType
                                        );
                                      }}
                                      onClick={(e) => (e.target.value = null)}
                                      className="upload_more_images_btn_input"
                                      style={{ display: "none" }}
                                    />
                                  </div>
                                </>
                              ))} */}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            );
          })
        ) : (
          <div className="empty_container">
            <Empty description={"No Sku Available"} />
          </div>
        )}
      </div>
      <div className="bottom_panel">
        <Stepper
          activeStep={6}
          nextStep={`/order-summary`}
          backStep={`/upload-images`}
          isSeggregation={false}
        />
        <div className="action_container">
          <button
            className="backBtn"
            onClick={() =>
              navigate(`/upload-images/${params.batchId}`, {
                state: { from: "sku-list" },
              })
            }
          >
            <img src={BackIcon} alt="backBtn" />
          </button>
          <Button
            text="Next"
            width={"140px"}
            height="50px"
            handleClick={() => navigate(`/order-summary/${params.batchId}`)}
            isDisabled={nextDisabled}
          />
        </div>
      </div>
      {isUploadColorSwatches && getUploadColorSwatches()}
      {uploadPopup && getUploadPopup()}
      {showDeleteModal && getDeleteModal()}
      {isListAddOns && getFilteredList()}
      {showDeleteSkuModal && getDeleteSkuModal()}
    </div>
  );
};

export default SkuList;
